import { useEffect } from 'react';

// Cierra un overlay (drawer, sheet) con Escape o con un tap/click fuera de su contenedor.
// Usa 'pointerdown' (no 'mousedown') para unificar mouse, touch y pen en un solo listener.
// Pensado para los overlays mobile nuevos (components/mobile/) — no reemplaza los patrones
// de click-afuera que ya existen en NavegacionLateral.js/las campanas desktop.
export default function useCerrarConEscapeYClickAfuera(refContenedor, activo, onCerrar) {
    useEffect(() => {
        if (!activo) return;

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') onCerrar();
        };
        const handlePointerDown = (e) => {
            if (refContenedor.current && !refContenedor.current.contains(e.target)) {
                onCerrar();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('pointerdown', handlePointerDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('pointerdown', handlePointerDown);
        };
    }, [refContenedor, activo, onCerrar]);
}
